"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var times_1 = (0, tslib_1.__importDefault)(require("lodash/times"));
var react_1 = (0, tslib_1.__importStar)(require("react"));
var flexbox_1 = require("../../flexbox");
var icon_button_1 = require("../../icon-button");
var padding_1 = require("../../padding");
var select_1 = (0, tslib_1.__importDefault)(require("./select"));
var DEFAULT_YEAR_RANGE = 100;
function CalendarHeader(props) {
    var maxYear = props.maxYear, minYear = props.minYear, calendar = props.calendar;
    var increaseMonth = calendar.increaseMonth, decreaseMonth = calendar.decreaseMonth, setYear = calendar.setYear, setMonth = calendar.setMonth, year = calendar.year, month = calendar.month;
    var yearOptions = (0, react_1.useMemo)(function () {
        var currentYear = new Date().getFullYear();
        var max = maxYear || currentYear + DEFAULT_YEAR_RANGE;
        var min = minYear || currentYear - DEFAULT_YEAR_RANGE;
        var years = [];
        (0, times_1.default)(max - min + 1, function (year) { return years.push(year + min); });
        return years.reverse().map(function (val) { return react_1.default.createElement("option", { key: val }, val); });
    }, [minYear, maxYear]);
    return (react_1.default.createElement(flexbox_1.Flexbox, { justifyContent: "space-between", alignItems: "center", width: "100%" },
        react_1.default.createElement(flexbox_1.FlexCell, null,
            react_1.default.createElement(icon_button_1.IconButton, { type: "chevronLeft", onClick: decreaseMonth })),
        react_1.default.createElement(flexbox_1.FlexCell, { flex: 1 },
            react_1.default.createElement(padding_1.Padding, { x: 4 },
                react_1.default.createElement(flexbox_1.Flexbox, { width: "100%" },
                    react_1.default.createElement(padding_1.Padding, { right: 4, style: { flex: '1.5' } },
                        react_1.default.createElement(select_1.default, { minWidth: "100px", value: month, onChange: setMonth },
                            react_1.default.createElement("option", null, "January"),
                            react_1.default.createElement("option", null, "February"),
                            react_1.default.createElement("option", null, "March"),
                            react_1.default.createElement("option", null, "April"),
                            react_1.default.createElement("option", null, "May"),
                            react_1.default.createElement("option", null, "June"),
                            react_1.default.createElement("option", null, "July"),
                            react_1.default.createElement("option", null, "August"),
                            react_1.default.createElement("option", null, "September"),
                            react_1.default.createElement("option", null, "October"),
                            react_1.default.createElement("option", null, "November"),
                            react_1.default.createElement("option", null, "December"))),
                    react_1.default.createElement("div", { style: { flex: '1' } },
                        react_1.default.createElement(select_1.default, { minWidth: "60px", value: year, onChange: function (newYear) { return setYear(Number(newYear)); } }, yearOptions))))),
        react_1.default.createElement(flexbox_1.FlexCell, null,
            react_1.default.createElement(icon_button_1.IconButton, { type: "chevronRight", onClick: increaseMonth }))));
}
exports.default = CalendarHeader;
//# sourceMappingURL=header.js.map